<span class="gauge-img-wrap" [style.--gauge-size.px]="size" role="img" [attr.aria-label]="alt">
  <img
    class="gauge-img"
    [src]="imageSrc"
    [alt]="alt"
    (error)="onImgError($event)"
    [attr.title]="showTooltip ? alt : null" />
</span>
